export default __webpack_public_path__ + "static/media/SG-Red-0003.12433975.png";